import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

const Icon = ({ style, name, title }) => (
  <svg className={`icon-${name}`} css={[ownStyle, style]}>
    <title>{title}</title>
    <use xlinkHref={`#icon-${name}`} />
  </svg>
);

export const CopySVG = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    viewBox='0 96 960 960'
    width='16'
    fill='rgba(0, 0, 0, .5)'>
    <path d='M200 936q-33 0-56.5-23.5T120 856V296h80v560h440v80H200Zm160-160q-33 0-56.5-23.5T280 696V216q0-33 23.5-56.5T360 136h400q33 0 56.5 23.5T840 216v480q0 33-23.5 56.5T760 776H360Zm0-80h400V216H360v480Zm0 0V216v480Z' />
  </svg>
);

export const CheckSVG = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    viewBox='0 96 960 960'
    width='16'
    fill='rgba(0, 0, 0, .5)'>
    <path d='M382 792 154 564l56-56 172 172 368-368 56 56-424 424Z' />
  </svg>
);

Icon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
};

const ownStyle = css`
  display: inline-block;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
`;

export default Icon;
